export default __webpack_public_path__ + "static/shotdok-og-ac10cff0bca9d5ab1e2ce5ef40a61066.png";